import { ReactComponent as ConditionIcon } from './Condition.svg'
import styles from './ConditionNode.module.scss'

function ConditionNode({ value, unit, onClick, isDisabledByPrevious = false }) {
  const displayText = `${value} ${unit}`
  const wrapperClassName = isDisabledByPrevious
    ? `${styles.wrapper} ${styles.disabledByPrevious}`
    : styles.wrapper

  return (
    <div className={wrapperClassName}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.icon}>
            <ConditionIcon />
          </div>
          <span className={styles.label}>If the guest hasn't completed a booking within</span>
          <button className={styles.timeButton} onClick={isDisabledByPrevious ? undefined : onClick}>
            {displayText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConditionNode
